require('./mortgageRequestHeaderCalculateQuota.scss');

//@vendor
const React = require('react');
const classnames = require('classnames');
const PropTypes = require('prop-types');
//@core
const { formatText, FormattedText } = require('core/i18n').i18n;
//@commons
import { ModalCustom } from 'commonsComponents/modalCustom';
const { OKLink } = require('commonsComponents/OKLink');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
//@components
const FixedMortgageTable = require('./mortgageRequestTypeMortgageTables/fixedMortgageTable');
const VariableMortgageTable = require('./mortgageRequestTypeMortgageTables/variableMortgageTable');
const MixedMortgageTable = require('./mortgageRequestTypeMortgageTables/mixedMortgageTable');
//constants
const { MORTGAGE_PRODUCT_NUMBER } = require('constants/mortgageRequestType');
const { recordLink } = require('utilities/tagging');
const { PREAPPROVAL_RECORD_LINK_TAGGING_PROCESS, afiMortgageProductTypes, PREAPPROVAL_CALCULATE_QUOTA_HEADER } = require('constants/mortgageRequestPreApproval');
const {
    MORTGAGE_PAYMENT_TABLE_V2,
    MORTGAGE_PAYMENT_TABLE,
    MORTGAGE_PRICING_WITHOUT_LTV,
} = require('constants/flagBasedFeatures');

class MortgageRequestHeaderCalculateQuota extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedMortgageModal: MORTGAGE_PRODUCT_NUMBER.FIJO,
            showModal: false
        }
        this.handleOnModalOpen = this.onModalOpen.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    buildFixedModalContent() {
        const {
            immFlagBasedFeatures,
        } = this.props;
        const keyModalFooter = 'modalFixedFooterText';
        const footer = this.buildDisclaimer(keyModalFooter);
        const isMortgageTableEnabled = immFlagBasedFeatures.get(MORTGAGE_PAYMENT_TABLE);
        const isBuildedTableEnabled = immFlagBasedFeatures.get(MORTGAGE_PRICING_WITHOUT_LTV);
        const mortgageTableNoConditions = isMortgageTableEnabled && !isBuildedTableEnabled ? (
            <FixedMortgageTable
                isMortgageTableEnabled={isMortgageTableEnabled}
                noConditions={true}
            />
        ) : null;

        return (
            <div className="mortgage-request-header-calculate-quota__table-container">
                <FixedMortgageTable
                    isMortgageTableEnabled={isMortgageTableEnabled}
                    noConditions={false}
                    showBuildedTable={isBuildedTableEnabled}
                />
                {mortgageTableNoConditions}
                {footer}
            </div>

        );
    }

    buildDisclaimer(modalFooterContext) {
        const footerText = `calculateQuotaHeader-calculateQuotaHeader_${modalFooterContext}`;
        return (
            <div className="mortgage-request-header-calculate-quota__disclaimer">
                <FormattedText value={footerText} />
            </div>
        );
    }

    buildVariableModalContent() {
        const {
            immFlagBasedFeatures,
        } = this.props;
        const keyModalFooter = 'modalVariableFooterText';
        const footer = this.buildDisclaimer(keyModalFooter);
        const isMortgageTableEnabled = immFlagBasedFeatures.get(MORTGAGE_PAYMENT_TABLE);
        const isBuildedTableEnabled = immFlagBasedFeatures.get(MORTGAGE_PRICING_WITHOUT_LTV);
        const mortgageTableNoConditions = isMortgageTableEnabled && !isBuildedTableEnabled ? (
            <VariableMortgageTable
                isMortgageTableEnabled={isMortgageTableEnabled}
                noConditions={true}
            />
        ) : null;

        return (
            <div className="mortgage-request-header-calculate-quota__table-container">
                <VariableMortgageTable
                    isMortgageTableEnabled={isMortgageTableEnabled}
                    noConditions={false}
                    showBuildedTable={isBuildedTableEnabled}
                />
                {mortgageTableNoConditions}
                {footer}
            </div>
        );
    }

    buildMixedModalContent() {
        const {
            immFlagBasedFeatures,
        } = this.props;
        const keyModalFooter = 'modalMixedFooterText';
        const footer = this.buildDisclaimer(keyModalFooter);
        const isMortgageTableEnabled = immFlagBasedFeatures.get(MORTGAGE_PAYMENT_TABLE);
        const isBuildedTableEnabled = immFlagBasedFeatures.get(MORTGAGE_PAYMENT_TABLE_V2);
        const mortgageTableNoConditions = isMortgageTableEnabled;

        return (
            <div className="mortgage-request-header-calculate-quota__table-container">
                <MixedMortgageTable
                    isMortgageTableEnabled={isMortgageTableEnabled}
                    noConditions={true}
                    showBuildedTable={isBuildedTableEnabled}
                />
                {mortgageTableNoConditions}
                {footer}
            </div>

        );
    }

    showModal(selectedMortgageModal) {
        this.setState({
            selectedMortgageModal,
            showModal: true
        })
    }

    closeModal() {
        const { MODAL_MORTGAGE_MORE_INFORMATION: { EVENT_CATEGORY, ACTION_EVENT_CLOSE } } = PREAPPROVAL_RECORD_LINK_TAGGING_PROCESS;
        const actionEventClose = ACTION_EVENT_CLOSE.replace('%s', this.getSelectedMortgage().toLowerCase());

        this.setState({
            showModal: false
        }, () => {
            recordLink(EVENT_CATEGORY, actionEventClose);
        });
    }

    getSelectedMortgage() {
        let selectedMortgage = '';

        switch (this.state.selectedMortgageModal) {
            case MORTGAGE_PRODUCT_NUMBER.FIJO:
                selectedMortgage = afiMortgageProductTypes.FIJO;
                break;
            case MORTGAGE_PRODUCT_NUMBER.VARIABLE:
                selectedMortgage = afiMortgageProductTypes.VARIABLE;
                break;
            default:
                selectedMortgage = afiMortgageProductTypes.MIXTO;
                break;
        }

        return selectedMortgage;
    }

    onModalOpen() {
        const { MODAL_MORTGAGE_MORE_INFORMATION: { EVENT_CATEGORY, ACTION_EVENT_OPEN } } = PREAPPROVAL_RECORD_LINK_TAGGING_PROCESS;
        const actionEvent = ACTION_EVENT_OPEN.replace('%s', this.getSelectedMortgage().toLowerCase());
        recordLink(EVENT_CATEGORY, actionEvent);
    }

    buildModal() {
        let modalTitleText;
        let content = '';

        switch (this.state.selectedMortgageModal) {
            case MORTGAGE_PRODUCT_NUMBER.FIJO:
                modalTitleText = (
                    <FormattedText
                        value="calculateQuotaHeader-calculateQuotaHeader_fixedMortgageTitleModal"
                        format="uppercase"
                    />
                );
                content = this.buildFixedModalContent();
                break;
            case MORTGAGE_PRODUCT_NUMBER.VARIABLE:
                modalTitleText = (
                    <FormattedText
                        value="calculateQuotaHeader-calculateQuotaHeader_variableMortgageTitleModal"
                        format="uppercase"
                    />
                );
                content = this.buildVariableModalContent();
                break;
            default:
                modalTitleText = (
                    <FormattedText
                        value="calculateQuotaHeader-calculateQuotaHeader_mixedMortgageTitleModal"
                        format="uppercase"
                    />
                );
                content = this.buildMixedModalContent();
                break;
        }

        const modalTitle = <OKBoxTitle value={modalTitleText} />

        return (
            <ModalCustom
                extraClass="mortgage-request-header-calculate-quota__modal"
                isOpen={this.state.showModal}
                onRequestClose={() => this.closeModal()}
                onAfterOpen={this.handleOnModalOpen}
            >
                <div className="row">
                    <div className="col-xs-12 mortgage-request-header-calculate-quota__modal-container">
                        {modalTitle}
                        {content}
                    </div>
                </div>
            </ModalCustom>
        )

    }

    buildHeader() {
        const items = PREAPPROVAL_CALCULATE_QUOTA_HEADER.ITEMS;

        return items.map((item, index) => {
            const textContainerClass = classnames('mortgage-request-header-calculate-quota__benefits-modal__text-container', {
                'mortgage-request-header-calculate-quota__benefits-modal__text-container--fixed-mortgage': item.mortgageType === MORTGAGE_PRODUCT_NUMBER.FIJO
            });
            const classes = classnames('icon', 'ok-icon-highlight',
                'mortgage-request-header-calculate-quota__benefits-icon', formatText(item.icon));

            const showMoreLink = (
                <OKLink
                    modifier="emphasize"
                    onClick={() => this.showModal(item.mortgageType)}
                    isOKLinkOld
                >
                    <FormattedText value={item.mortgageTypeCopyLink} />
                </OKLink>
            );

            const modalLinkInfo = <FormattedText value={item.modalLinkTextValue} className={item.modalLinkTextClassName} />

            const showLink = item.mortgageType ? showMoreLink : null;
            const modalLinkText = item.modalLinkTextValue ? modalLinkInfo : null;

            return (
                <div key={`benefits-${index}`}
                    className="col-xs-3 mortgage-request-header-calculate-quota__benefits   col-xs-12 col-sm-3 col-md-3">
                    <i className={classes} />
                    <div className="mortgage-request-header-calculate-quota__benefits-title">
                        <FormattedText value={item.title} />
                    </div>
                    <div className="ok-box-title__separator mortgage-request-header-calculate-quota__benefits-separator"></div>
                    <div className="mortgage-request-header-calculate-quota__benefits-subtitle">
                        <FormattedText value={item.descriptionValue} />
                    </div>
                    <div className="mortgage-request-header-calculate-quota__benefits-modal">
                        <p className={textContainerClass}>
                            {modalLinkText} {showLink}
                        </p>
                    </div>
                </div>
            );
        });
    }

    buildCollectiveHeader() {
        const items = PREAPPROVAL_CALCULATE_QUOTA_HEADER.COLLECTIVE_ITEMS;

        return items.map((item, index) => {
            const classes = classnames('icon', 'ok-icon-highlight',
                'mortgage-request-header-calculate-quota__benefits-icon', formatText(item.icon));
            return (
                <div key={`benefits-${index}`}
                    className="col-xs-3 mortgage-request-header-calculate-quota__benefits">
                    <i className={classes} />
                    <div className="mortgage-request-header-calculate-quota__benefits-title">
                        <FormattedText value={item.title} />
                    </div>
                    <div className="ok-box-title__separator mortgage-request-header-calculate-quota__benefits-separator"></div>
                    <div className="mortgage-request-header-calculate-quota__benefits-subtitle">
                        <FormattedText value={item.descriptionValue} />
                    </div>
                </div>
            );
        });
    }


    render() {
        const { isCollective } = this.props;
        const header = !isCollective ? this.buildHeader() : this.buildCollectiveHeader();
        const modal = this.buildModal();

        return (
            <div className="row mortgage-request-header-calculate-quota">
                {header}
                {modal}
            </div>
        )
    }
}

MortgageRequestHeaderCalculateQuota.propTypes = {
    immFlagBasedFeatures: PropTypes.object.isRequired,
    isCollective: PropTypes.object.isRequired,
}

module.exports = MortgageRequestHeaderCalculateQuota;
